import { render, staticRenderFns } from "./GroupHead.vue?vue&type=template&id=9e527ef8&"
import script from "./GroupHead.vue?vue&type=script&lang=js&"
export * from "./GroupHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports